import { Link as t } from "@chakra-ui/react";
import { ButtonLink as e } from "./button-link.js";
export {
  e as ButtonLink,
  t as Link
};
